import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SliderGalleryPageConfig } from '../types'
import type { SliderGalleryProperties } from '@wix/thunderbolt-components-native'
import { name } from '../symbols'

const sliderGalleryPageConfig: PageConfigFn<SliderGalleryPageConfig> = ({ api }: VsmContext) => {
	const sliderGalleries = api.components.getComponentsByType('SliderGallery')
	const galleryIds = Object.keys(sliderGalleries)

	if (galleryIds.length === 0) {
		return { shouldLoadPageFeature: false }
	}

	const isMobileView = api.env.isMobileView()
	const galleryConfigs: Record<string, { loop: boolean; speed: number; margin: number; isMobileView: boolean }> = {}

	for (const galleryId of galleryIds) {
		const props = api.components.getCompProps<SliderGalleryProperties>(galleryId)
		galleryConfigs[galleryId] = {
			loop: props?.loop ?? false,
			speed: props?.maxSpeed ?? 0,
			margin: props?.margin ?? 0,
			isMobileView,
		}
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: { galleryConfigs },
	}
}

export const pageConfig: PageConfigEntry<SliderGalleryPageConfig> = {
	name,
	configFactory: sliderGalleryPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
